module.exports = __webpack_public_path__ + "img/logo_top.d8433ec7.svg";